import { useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { initLiteTradeAction, pingLiteTradeAction, } from "../../modules/LiteTrade/liteTradeActions.js";
import { getLiteTradeConfig } from "../../modules/LiteTrade/liteTradeSelectors.js";
import LiteTradeWSConnector from "./LiteTradeWSConnector.jsx";
import useEffectOnce from "../../hooks/useEffectOnce.js";
import { Loader } from "../../components/Loader/Loader.jsx";

/**
 * Раньше это был провайдер, теперь просто коннектор с автопингом на WebSocket
 */
function LiteTradeProvider(props) {
    const {
        liteTradeConfig,

        pingLiteTrade,
        initLiteTrade,
    } = props;

    useEffectOnce(() => {
        initLiteTrade();
    });

    useEffect(() => {
        const timer = setInterval(() => {
            pingLiteTrade();
        }, 1000 * 60);
        return () => {
            clearTimeout(timer);
        }
    }, [pingLiteTrade]);

    if (!liteTradeConfig) {
        return <Loader show={true}/>
    }

    return <>
        <LiteTradeWSConnector/>
    </>
}

const mapStateToProps = createStructuredSelector({
    liteTradeConfig: getLiteTradeConfig,
});

const mapDispatchToProps = (dispatch) => ({
    initLiteTrade: payload => dispatch(initLiteTradeAction(payload)),
    pingLiteTrade: (payload) => dispatch(pingLiteTradeAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LiteTradeProvider);
